import makeApiCall from "./master/axiosIndex";

export const timeLogSettingsApis = {
  createTimeLogSettings: async (data: any): Promise<any> => {
    return makeApiCall({
      url: "/timelog-settings/create",
      method: "post",
      data,
    });
  },
  getTimeLogSettingsList: async (data: any): Promise<any> => {
    return makeApiCall({
      url: "/timelog-settings/list",
      method: "get",
      params: data,
    });
  },
  getTimeLogSettingsListOneByProjectId: async (id: string|number): Promise<any> => {
    return makeApiCall({
      url: `/timelog-settings/listOneByProjectId/${id}`,
      method: "get",
    });
  },
  updateTimeLogSettings: async (id: string|number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/timelog-settings/update/${id}`,
      method: "put",
      data,
    });
  },
  deleteTimeLogSettings: async (id: string): Promise<any> => {
    return makeApiCall({
      url: `/timelog-settings/delete/${id}`,
      method: "delete",
    });
  },
};
